import moment from 'moment';
import { formatUTCdateWithTime } from '../general';

/** @type {import('./_types').DisplayField[]} */
export const displayFields = [
  {
    label: 'Contact Name',
    field: 'contact_name',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },

  {
    label: 'Contact Email',
    field: 'contact_email',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },

  {
    label: 'Contact ID',
    field: 'contact_id',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: false
  },

  {
    label: 'Vendor',
    field: 'vendor',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },

  {
    label: 'Status',
    field: 'status',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },

  {
    label: 'Last Status Update',
    field: 'last_status_update',
    selector: row =>formatUTCdateWithTime(row.last_status_update) ,
		cell: row => formatUTCdateWithTime(row.last_status_update),
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },

  {
    label: 'Related Accounts',
    field: 'related_accounts',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },

  {
    label: 'View All Related Accounts',
    field: 'view_all_related_accounts',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },

  {
    label: 'Actions',
    field: 'actions',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },

];

export const getDisplayFields = (isDefault=false,keys = null) => {
  const visibleFields = displayFields.filter(f => isDefault ? f.isDefault : true);

  if (!keys||keys.length==0) return visibleFields;

  return keys
    .map(key => visibleFields.find(f => f.field === key))
    .filter(Boolean);
};
